import m2Sidebar from "@components/sidebar/m2_sidebar";
import editInvoice from "@components/invoice/editInvoice"
import invoiceListCom from "@components/invoice/invoiceListCom"
export default {
  components: {
    m2Sidebar,
    editInvoice,
    invoiceListCom
  },
  data() {
    return {
      batchDataList: [],
      applyList: [],
      dialogVisible: false,
      scopeRow: "",
      isShow: false,
      modifyInfo: {
        invoice_title: "",
        invoice_tax_no: "",
        email: "",
        address_info: "",
        telephone_info: "",
        bank: "",
        bank_account: "",
        is_need: 1,
        elec_invoice_type: 2,
        order_no: "",
        id: "",
        invoice_type: "",
      },
      tabShow: 1,
    };
  },
  computed: {
    exam_type: {
      get() {
        return this.$store.state.examInfo.currentExamInfo.exam_type;
      }
    }
  },
  watch: {
    tabShow(val) {
      if (val == 1) {
        this.getInvoiceData();
      } else if (val == 2) {
        this.getApplyInvoiceList();
      }
    }
  },
  methods: {
    modifyInvoice(row, id, is_enable, invoice_type) {
      this.modifyInfo = {
        ...this.modifyInfo,
        ...row,
        id,
        is_enable,
        invoice_type
      };
      this.dialogVisible = true;

    },
    handleTabChange(tabNum) {
      this.tabShow = tabNum;
    },
    handleRedRush(row, id) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$http
        .post(globalProvider.serviceUrl("e_reg/a/ri"), {
          bi: id,
          on: row.order_no
        })
        .then(data => {
          loading.close();
          this.getInvoiceData();
          if (data.body.code == resultCode.Success) {
            this.$alert(getErrorMessage(data.body.data), "提示", {
              confirmButtonText: "确定"
            });
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message), "提示", {
              confirmButtonText: "确定"
            });
          }
        });
    },
    getInvoiceData() {
      this.$http.post(globalProvider.serviceUrl("e_reg/q/aol")).then(data => {
        if (data.body.code === resultCode.Success) {
          this.batchDataList = data.body.data;
        } else if (data.body.code == resultCode.NotSuccess) {
          this.$alert(getErrorMessage(data.body.message));
        }
      });
    },

    handleEditInvoiceChange(val) {

      if (val) {
        this.modifyConfirm(val)
      } else {
        this.dialogVisible = false;
      }
    },
    //修改保存
    modifyConfirm(modifyInfo) {
      this.$http
        .post(globalProvider.serviceUrl("e_reg/u/ic"), {
          is: modifyInfo.is_need + "",
          eit: modifyInfo.elec_invoice_type + "",
          it: modifyInfo.invoice_title,
          itn: modifyInfo.invoice_tax_no,
          em: modifyInfo.email,
          add: modifyInfo.address_info,
          tel: modifyInfo.telephone_info,
          bank: modifyInfo.bank,
          b_account: modifyInfo.bank_account,
          bi: modifyInfo.id,
          on: modifyInfo.order_no,
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.$alert("保存成功", {
              confirmButtonText: "确定",
              callback: action => {
                this.dialogVisible = false;
                this.getInvoiceData();
                this.getApplyInvoiceList();
              }
            });
          } else if (data.body.code == resultCode.NotSuccess) {
            this.dialogVisible = false;
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    //获取发票申请列表
    getApplyInvoiceList() {
      this.$http.post(globalProvider.serviceUrl("e_reg/q/oil")).then(data => {
        if (data.body.code === resultCode.Success) {
          this.applyList = data.body.data;
          if (this.applyList.length == 0) {
            this.tabShow=1;
          }
        } else if (data.body.code == resultCode.NotSuccess) {
          this.$alert(getErrorMessage(data.body.message));
        }
      });
    },
    applyInvoice(row, id) {
      let on = row.order_no;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$http
        .post(globalProvider.serviceUrl("e_reg/a/bi"), {
          on,
          bi: id
        })
        .then(data => {
          loading.close();
          if (data.body.code === resultCode.Success) {
            this.$alert(
              "电子发票申请已发出，系统将尽快为您开具电子发票",
              "提示信息", {
              confirmButtonText: "确定",
              callback: () => {
                this.getInvoiceData();
              }
            }
            );
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    }
  },
  created: function () {
    this.$store.commit("setHeaderState", "0");
    this.getInvoiceData();
    this.getApplyInvoiceList();
  }
};